import { Injectable, inject } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PermissionDtoString } from 'src/app/shared/enums/permission-name.enum';
import { safelyCreateHttpParams } from './api/api-utils';
import { components, operations } from './api/generated/ix-api.types';
import { IxRestApi } from './api/ix-rest-api';

export type ViewAccessDto = components['schemas']['ViewAccessDto'];
export type PermissionDto = components['schemas']['PermissionDto'];
export type ViewName = components['schemas']['ViewAccessDto']['viewName'];
export type SubViewName = components['schemas']['ViewAccessSubDto']['viewName'];

@Injectable({
  providedIn: 'root',
})
export class ViewAccessApiService {
  readonly #ixRestApi = inject(IxRestApi);

  getViewAccess(path: operations['getViewAccess']['parameters']['path']) {
    const defaultViews: ViewAccessDto[] = [
      { viewName: 'DASHBOARD' },
      { viewName: 'ERROR' as ViewAccessDto['viewName'] },
    ];

    return this.#ixRestApi.get({ pathname: '/api/projects/{projectId}/viewaccess', options: { path } }).pipe(
      catchError(() => of([] as ViewAccessDto[])),
      map(views => views.concat(defaultViews)),
    );
  }

  getViewPermissions(
    path: operations['getViewPermissions']['parameters']['path'],
    query: operations['getViewPermissions']['parameters']['query'],
  ) {
    const defaultPermissions: PermissionDto[] = [];

    return this.#ixRestApi
      .get(
        { pathname: '/api/projects/{projectId}/viewpermissions', options: { path } },
        { params: safelyCreateHttpParams(query) },
      )
      .pipe(catchError(() => of(defaultPermissions)));
  }
}

export function hasViewPermission(permission: PermissionDtoString, permissions: PermissionDto[]): boolean {
  return permissions.some(view => view.permissionName === permission && view.hasPermission);
}
